import type { GAQFacet, IsUserExistingCustomerRequest, PriceChangeRequest, PriceChangeResponse, PricingSearchRequest, PricingSearchResponse, PricingSearchResult, ServiceTypesByZipcodeResponse } from "../../../typings/GetAQuote";
import { BaseStatusResponse, request, requestWithStatus } from "../../api/ApiHelpers";

export async function fetchIsExistingCustomer(url: string, queryParamObj: IsUserExistingCustomerRequest): Promise<BaseStatusResponse> {
    return await requestWithStatus<BaseStatusResponse>({ url: url, params: queryParamObj }).then((response) => {
        return response;
    });
}

export async function fetchServiceTypesByZipcode(url: string, zip: string,  latitude: number | null, longitude?: number | null ): Promise<ServiceTypesByZipcodeResponse> {
    return await requestWithStatus<ServiceTypesByZipcodeResponse>({ url, params: { postalCode: zip, latitude, longitude } }).then((response) => {
        return response;
    });
}

export async function fetchIsServiceTypeAvailable(url: string, postalCode: string, serviceTypeId: number): Promise<boolean> {
    return await request({ url, params: { postalcode: postalCode } }).then((response) => {
        if (Array.isArray(response)) {
          if(serviceTypeId === 0){
            return response.length > 0;
          }
          else{
            return response.some(x => x.serviceTypeId === serviceTypeId);
          }
        }
        return false;
    });
}

export async function fetchPricingResults(url: string, queryParamObj: PricingSearchRequest): Promise<PricingSearchResponse> {
    return await requestWithStatus<PricingSearchResponse>({ url, params: queryParamObj }).then((response) => {
        return response;
    });
}

export async function fetchPricingUpdate(url: string, queryParamObj: PriceChangeRequest): Promise<PriceChangeResponse> {
    return await request<PriceChangeResponse>({ url, params: queryParamObj }).then((response) => {
        return response;
    });
}

export async function postPricingSubmit(url: string, dataObj): Promise<BaseStatusResponse> {
    return await requestWithStatus<BaseStatusResponse>({ url, method: 'post', data: dataObj }).then((response) => {
        return response;
    });
}

export function formatCardPrice(val: number, includeDecimalDot = false): string {
    const splitByDecimal = val.toFixed(2).toString().split('.');
    let str = `<sup>$</sup><span>${splitByDecimal[0]}</span>`;
    if (splitByDecimal.length > 1) {
        str += `<sup>${includeDecimalDot ? '.' + splitByDecimal[1] : splitByDecimal[1]}</sup>`;
    }
    return str;
}

export function getGroupedFacets(results: PricingSearchResult[]): GAQFacet[] {
    if (!results.some(r => r.facets)) {
        return [];
    }
    // const newResults = JSON.parse(JSON.stringify(results)) as PricingSearchResult[];

    const onlyFacetsFromResults = [].concat(...results.map((r) => {
        // deep clone result objects so we don't change the actual results!
        return JSON.parse(JSON.stringify(r.facets));
    }));

    const onlyFacetsFromResultsNoDuplicates = [...new Map(onlyFacetsFromResults.map(o => [JSON.stringify(o), o])).values()];

    const groupedFacets = onlyFacetsFromResultsNoDuplicates.reduce((prev, curr) => {
        // note: prev = [{}]

        // set all facet values to unchecked
        curr.facetValues.forEach(fv => {
            fv.checked = false;
        });

        if (prev.length) {
            // if the current grouping already exists
            const existingGrouping = prev.find(f => f.facetTitle === curr.facetTitle);
            if (existingGrouping) {
                existingGrouping.facetValues.push(...curr.facetValues);
            } else {
                prev.push(curr);
            }
        } else {
            prev.push(curr);
        }

        return prev;
    }, []);

    return groupedFacets;
}
